export interface AddressApiResponse {
  id: number;
  street: string;
  streetNr: string,
  city: string;
  land: string,
  zipCode: string;
  country: string;
  alternativeName: string;
  phone: string;
  fax: string;
  website: string;
  isMain: string;
  organizationId: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
}

export interface AddressModel {
  id: number;
  street: string;
  city: string;
  country: string;
  fax: string;
  alternativeName: string;
  isMain: string;
  land: string,
  organizationId: number;
  phone: string;
  streetNr: string,
  website: string;
  zipCode: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
}

export class Address implements AddressModel {
  id = -1;
  city = '';
  country = '';
  fax = '';
  alternativeName = '';
  isMain = '';
  land = '';
  organizationId = -1;
  phone = '';
  street = '';
  streetNr = '';
  website = '';
  zipCode = '';
  createdAt = '';
  updatedAt = '';
  deletedAt = '';

  constructor(dto?: AddressModel) {
    if (!dto) {
      return;
    }
    this.id = dto.id;
    this.city = dto.city;
    this.country = dto.country;
    this.fax = dto.fax;
    this.alternativeName = dto.alternativeName;
    this.isMain = dto.isMain;
    this.land = dto.land;
    this.organizationId = dto.organizationId;
    this.phone = dto.phone;
    this.website = dto.website;
    this.street = dto.street;
    this.streetNr = dto.streetNr;
    this.zipCode = dto.zipCode;
    this.createdAt = dto.createdAt;
    this.updatedAt = dto.updatedAt;
    this.deletedAt = dto.deletedAt;
  }

  static parseDto(dto: Array<AddressApiResponse>): Array<Address> {
    return dto.map((address: AddressApiResponse): Address => {
    return new Address({
      id: address.id,
      city: address.city,
      country: address.country,
      fax: address.fax,
      alternativeName: address.alternativeName,
      isMain: address.isMain,
      land: address.land,
      organizationId: address.organizationId,
      phone: address.phone,
      street: address.street,
      website: address.website,
      streetNr: address.streetNr,
      zipCode: address.zipCode,
      createdAt: address.createdAt,
      updatedAt: address.updatedAt,
      deletedAt: address.deletedAt,
    });
    });
  }

  static jsonSerialize(dto: Array<AddressApiResponse>): Array<Address> {
    return dto.map((address: AddressApiResponse): Address => {
      return new Address({
        id: address.id,
        city: address.city,
        country: address.country,
        fax: address.fax,
        alternativeName: address.alternativeName,
        isMain: address.isMain,
        land: address.land,
        organizationId: address.organizationId,
        phone: address.phone,
        street: address.street,
        website: address.website,
        streetNr: address.streetNr,
        zipCode: address.zipCode,
        createdAt: address.createdAt,
        updatedAt: address.updatedAt,
        deletedAt: address.deletedAt
      });
    });
  }
}
